import { 
	GET_PROJECT_TWRS, 
	GET_PROJECT_TWR,
	CREATE_PROJECT_TWR,
	UPDATE_PROJECT_TWR,
	DESTROY_PROJECT_TWR,
} from "./actions"

export function ProjectTwrsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_TWRS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_TWR}_FULFILLED`:
		case `${CREATE_PROJECT_TWR}_FULFILLED`:
		case `${UPDATE_PROJECT_TWR}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_TWR}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectTwrsReducer } from "modules/project/twrs/reducer"

// project_twrs:ProjectTwrsReducer,
